import FHIR from 'fhirclient'
import _isEmpty from 'lodash/isEmpty'

import loSto from '../../../config/loSto'
import { LO_STO, SECONDARY_EMR_TYPE } from '../../../lib'
import fhirConfigReader from '../../../readers/fhirConfig'

const generateEpicRedirectUrl = (epicFhirConfig) => {
  try {
    const authorizeUrl = fhirConfigReader.authorizeUrl(epicFhirConfig)

    const redirectUrl = fhirConfigReader.redirectUri(epicFhirConfig)
    const encodedRedirectUrl = encodeURIComponent(redirectUrl)

    const clientId = fhirConfigReader.clientId(epicFhirConfig)
    const encodedClientId = encodeURIComponent(clientId)

    const epicUrl = `${authorizeUrl}&redirect_uri=${encodedRedirectUrl}&client_id=${encodedClientId}&state=abc123`
    return epicUrl
  } catch (error) {
    console.error(
      `EPIC EMR Redirection Error: Failed to generate url, ${error}`
    )
    return ''
  }
}

const handleEpicRedirection = (epicFhirConfig) => {
  const epicRedirectUrl = generateEpicRedirectUrl(epicFhirConfig)
  window.location.href = epicRedirectUrl
}

const isValidCernerConfiguration = (cernerFhirConfig) => {
  const url = fhirConfigReader.url(cernerFhirConfig)
  const spec = fhirConfigReader.spec(cernerFhirConfig)
  const tenantId = fhirConfigReader.tenantId(cernerFhirConfig)
  const clientId = fhirConfigReader.clientId(cernerFhirConfig)
  const redirectUrl = fhirConfigReader.redirectUri(cernerFhirConfig)

  return !(_isEmpty(url) || _isEmpty(spec) || _isEmpty(tenantId) || _isEmpty(clientId) || _isEmpty(redirectUrl))
}

const handleCernerRedirection = (cernerFhirConfig) => {
  try {
    if (isValidCernerConfiguration(cernerFhirConfig)) {
      const url = fhirConfigReader.url(cernerFhirConfig)
      const spec = fhirConfigReader.spec(cernerFhirConfig)
      const tenantId = fhirConfigReader.tenantId(cernerFhirConfig)
      const clientId = fhirConfigReader.clientId(cernerFhirConfig)
      const redirectUrl = fhirConfigReader.redirectUri(cernerFhirConfig)
      const issuer = `${url}/${spec}/${tenantId}`

      FHIR.oauth2.authorize({
        client_id: clientId,
        scope: 'openid profile online_access',
        iss: issuer,
        redirectUri: redirectUrl
      })
    } else {
      alert('Cannot find the Cerner tenant to redirect to. Please contact support@suki.ai for assistance.')
    }
  } catch (error) {
    console.error(
      `CERNER EMR Redirection Error: Failed to generate url, ${error}`
    )
  }
}

const EMR_VS_REDIRECT_HANDLERS = {
  [SECONDARY_EMR_TYPE.EPIC_EMR]: handleEpicRedirection,
  [SECONDARY_EMR_TYPE.CERNER_EMR]: handleCernerRedirection
}

const handleEmrRedirection = () => {
  const emrIntegrationDetails =
  loSto.get(LO_STO.EMR_INTEGRATION_DETAILS) || {}
  const { emr, config } = emrIntegrationDetails
  const redirectHandler = EMR_VS_REDIRECT_HANDLERS[emr]
  redirectHandler(config)
}

export { handleEmrRedirection }
